import SohoLoader from '../common/SohoLoader/SohoLoader'
import './ChartPanel.css'

const ChartPanel = ({
  title,
  titleAccessory,
  subtitle,
  tabs,
  activeTab,
  onTabChange,
  actions,
  footerActions,
  loading = false,
  loadingMessage = 'Loading chart data…',
  empty = false,
  emptyMessage = 'No data available',
  className = '',
  size = 'md',
  dataChartId,
  children,
}) => {
  const showHeader = title || subtitle || actions || (tabs && tabs.length > 0)
  const bodyClass = `rg-panel__body rg-panel__body--${size}`
  const loaderSize = size === 'sm' ? 'sm' : size === 'lg' ? 'lg' : 'md'

  return (
    <div className={`rg-panel ${className}`} data-chart-id={dataChartId || undefined}>
      {showHeader && (
        <div className="rg-panel__header">
          <div className="rg-panel__title">
            {title && (
              <div className="rg-panel__title-row">
                <h3 className="rg-panel__title-text">{title}</h3>
                {titleAccessory}
              </div>
            )}
            {subtitle && <p className="rg-panel__subtitle">{subtitle}</p>}
          </div>
          {(actions || (tabs && tabs.length > 0)) && (
            <div className="rg-panel__controls">
              {actions && <div className="rg-panel__actions">{actions}</div>}
              {tabs && tabs.length > 0 && (
                <div className="rg-panel__tabs" role="tablist">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      className={`rg-panel__tab ${activeTab === tab.id ? 'rg-panel__tab--active' : ''}`}
                      onClick={() => onTabChange?.(tab.id)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      <div className={bodyClass}>
        {loading && (
          <div className="rg-panel__state rg-panel__state--loading">
            <SohoLoader size={loaderSize} message={loadingMessage} />
          </div>
        )}
        {!loading && empty && <div className="rg-panel__state">{emptyMessage}</div>}
        {!loading && !empty && children}
      </div>
      {footerActions && <div className="rg-panel__footer">{footerActions}</div>}
    </div>
  )
}

export default ChartPanel
